import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const MenuLoginButton = styled.button<Props>`
  background: ${(props) =>
    props.focused ? `${Colors['modal']['button']['light']}` : 'none'};
  border: ${Colors['modal']['button']['light']} ${2 * Screen.widthRatio}px solid;
  border-radius: ${50 * Screen.widthRatio}px;
  color: ${(props) =>
    props.focused
      ? `${Colors['modal']['button']['text']}`
      : `${Colors['modal']['button']['light']}`};
  cursor: ${(props) => (props.focused ? 'pointer' : 'default')};
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  height: ${60 * Screen.widthRatio}px;
  left: ${40 * Screen.widthRatio}px;
  padding: 0 ${24 * Screen.widthRatio}px;
  position: absolute;
  top: ${32 * Screen.widthRatio}px;
  width: auto;
`;

export default MenuLoginButton;
